import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16b227e1")

_pushScopeId("data-v-16b227e1")
const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "demo title text-center mb-2" }, "Lorem ipsum", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "demo title text-center negative mb-2" }, "Lorem ipsum", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleText = _resolveComponent("ExampleText")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_ExampleText, { class: "demo text" })
  ], 64))
})